import { createSelector } from '@ngrx/store';

import { FinancialEntityBranch } from '@models/swagger';
import { State } from './reducer';
import { selectFinancialEntityBranchState } from '../selectors';

export const getData = createSelector(selectFinancialEntityBranchState, (state: State) => state.data);

export const getError = createSelector(selectFinancialEntityBranchState, (state: State) => state.error);

export const getLoading = createSelector(selectFinancialEntityBranchState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: FinancialEntityBranch) => T) =>
  createSelector(selectFinancialEntityBranchState, (state: State) => fn(state.data));
